import type { FaireProductEntity } from "../../entity_types/product";

export const p_d7v3b8tdmz: FaireProductEntity = {
  token: "p_d7v3b8tdmz",
  type: "product",
  name: "The Toilet Water Dish",
  brandToken: "b_6qajwqdzz3",
  brandName: "BigMouth Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/5a2deb62fdfbcb43a6cec543c6f5fab579800fc799d9a5b821ad14e950f1b0fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dadfcdebaa04c4501ef9468a9691522394fd4fdbcc90c9cf205fe11c569defbb.jpeg",
    "https://cdn.faire.com/fastly/7ab65fed9805d8fb3bf5d1eae31d25e6c5007c43d66869b7d97859c2db28a3fb.jpeg",
    "https://cdn.faire.com/fastly/f438549019e31ae6b44aa9e3525a55915d82a40ecbde00ad18cc3e1254569b58.jpeg",
  ],
  priceDollars: 17.31,
  description:
    "When drinking from the bowl is a good thing \nOK so maybe Fido takes an occasional slurp from the throne, does that make him a bad dog? No—just have him drink from the mini version instead—it’s elevated, simple to use, and hilarious.\n\n * serve your pet drinking water how they really want it \n * elevated bowl offers healthier, ergonomic intake \n * automatically refills the bowl from a standard 2.0L bottle \n * sturdy, high quality ceramic construction \n * easy to clean",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:50.551Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
